"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayNumberFromBE = displayNumberFromBE;
/**
 * Function to format a given string
 *
 * Remove trailing zeros if '.00'
 * @param {any} input - The value to be formatted.
 * @returns {string} - Return formatted string
 */
function displayNumberFromBE(input) {
    if (input === undefined) {
        return "--";
    }
    var toDisplay = input.displayValue;
    if (toDisplay.endsWith(".00")) {
        toDisplay = `${toDisplay.substring(0, toDisplay.length - 3)}`;
    }
    if (input.displaySymbol !== undefined && input.displaySymbol !== "") {
        return `${input.displaySymbol}${toDisplay}`;
    }
    if (input.displayUnit !== undefined && input.displayUnit !== "") {
        return `${toDisplay}${input.displayUnit}`;
    }
    return `${toDisplay}`;
}
